import TutorialImage2 from "@/assets/images/tutorial-image2.png";
import { useTranslation } from "react-i18next";

function Page2() {
  const { t } = useTranslation("New");

  return (
    <div className="w-full flex flex-col gap-4 items-center ">
      <div className="w-[500px] h-[250px]">
        <img src={TutorialImage2} alt="tutorial" />
      </div>

      <div className="flex flex-col gap-4 mt-7">
        <p className="font-medium text-center">{t("onboardingDesc2")}</p>
      </div>
    </div>
  );
}

export default Page2;
